import cn from 'classnames';

import type { PropsWithChildren } from 'react';

import type { MenuGroupLabelProps } from './menu-group-label.types';

import './menu-group-label.scss';

export default function MenuGroupLabel(props: PropsWithChildren<MenuGroupLabelProps>): JSX.Element {
  const { children, className, ...rest } = props;

  const classes = cn('rbui-menu-group__label', className);

  return (
    <li className={classes} role="presentation" {...rest}>
      {children}
    </li>
  );
}

MenuGroupLabel.displayName = 'MenuGroupLabel';
